import React from 'react'

import cotiza from './../../UI/TopMenu/Icon_cotiza.svg'
//import testDrive from './../../UI/TopMenu/Icon_TestDrive.svg'
import soundOff from './../../UI/TopMenu/Icon_SoundOFF.svg'
import souindOn from './../../UI/TopMenu/Icon_SoundON.svg'
import doubleArrowBtn from './../../UI/general/arrow_btn.svg'
import { cotizaData } from '../../data/cotiza.data';

declare const window: any;

interface Props {
  openScene: boolean,
  handleMuteSong: () => void,
  isMuted: boolean,
  handleQuotation: (payload: boolean) => void,
  isQuotationOpened: boolean,
  currentModel: any,
  currentCompleteCar: any,
  enableInternalCotizaGlobally: boolean,
  handleCloseCarStudio: () => void,
}

interface State {
  isQuotationOpened: boolean
  modelLink: any
}

class TopMenu extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isQuotationOpened: false,
      modelLink: '',
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.isQuotationOpened !== prevProps.isQuotationOpened && this.props.isQuotationOpened === false){
      this.setState({
        isQuotationOpened: false
      })
    }
    if(this.props.isQuotationOpened !== prevProps.isQuotationOpened && this.props.isQuotationOpened === true){
      this.setState({
        isQuotationOpened: true
      })
    }
    if(this.props.currentCompleteCar !== prevProps.currentCompleteCar){
      var cotizaLinks: any = cotizaData()
      this.setState({
        modelLink: cotizaLinks[this.props.currentCompleteCar]
      })
    }
  }

  render(): React.ReactNode {
    
      return(
        <div className='full-top-menu-container'>
          <div className={'top-exit-btn'} style={{ animation: this.props.openScene ? '.8s moveDown ease-in-out forwards':'none' }} onClick={() => {this.props.handleCloseCarStudio()}}>
            <div className='top-exit-btn-img' ><img src={doubleArrowBtn} alt=''/></div>
            <div className='top-exit-btn-text'>CATÁLOGO</div>
          </div>

          <div 
          className='top-menu-container'
          style={{
            animation: this.props.openScene ? '.8s moveDown ease-in-out forwards':'none'
          }}
        >
          { this.props.enableInternalCotizaGlobally === true ?
          <div className={this.state.isQuotationOpened ? 'cotiza-menu-btn quotation-selected':'cotiza-menu-btn'} onClick={() => {
            this.setState({
               isQuotationOpened: !this.state.isQuotationOpened
            }, () => {
              this.props.handleQuotation(this.state.isQuotationOpened)
              window.dataLayer.push({ //si se desactiva esto, hay que comentar la linea 9 de este archivo.
                'event': 'info_request_click',
                'comp_product': {
                'position': 'page',
                'vehiculo_type': "car",
                'brand': "hyundai",
                'product_condition': "new",
                'model': this.props.currentCompleteCar.split(this.props.currentModel)[0].toLowerCase(),
                'version': this.props.currentModel.toLowerCase(),
                'fuel_type': null,
                'dealer_name': null
                }
              })
            })
          }}>
            <div className='cotizar-menu-icon'>
              <img src={cotiza} alt=''/>
            </div>
            <div className='cotizar-title'>Cotiza</div>
          </div>
          :
          <a href={this.state.modelLink} target='_blank' rel='noreferrer' style={{textDecoration: 'none'}}>
            <div className={this.state.isQuotationOpened ? 'cotiza-menu-btn quotation-selected':'cotiza-menu-btn'} onClick={() => {
                window.dataLayer.push({
                  'event': 'info_request_click',
                  'comp_product': {
                  'position': 'page',
                  'vehiculo_type': "car",
                  'brand': "hyundai",
                  'product_condition': "new",
                  'model': this.props.currentCompleteCar.split(this.props.currentModel)[0].toLowerCase(),
                  'version': this.props.currentModel.toLowerCase(),
                  'fuel_type': null,
                  'dealer_name': null
                  }
                })
              }}>
                <div className='cotizar-menu-icon'>
                  <img src={cotiza} alt=''/>
                </div>
                <div className='cotizar-title'>Cotiza</div>
            </div>
          </a>
          }

          {/*<div className='testdrive-menu-btn'>
            <div className='testdrive-menu-icon'>
              <img src={testDrive} alt=''/>
            </div>
            <div className='testdrive-title'>Test drive</div>
          </div>*/}
          <div className='sound-menu-btn' onClick={() => {
            this.props.handleMuteSong()
          }}>
            <div className='soundr-menu-icon'>
              <img src={!this.props.isMuted ? souindOn:soundOff} alt=''/>
            </div>
          </div>
        </div>
        </div>
      )
  }
}

export default TopMenu